import { render, staticRenderFns } from "./ChatMessagesList.vue?vue&type=template&id=0706fa3c&scoped=true&"
import script from "./ChatMessagesList.vue?vue&type=script&lang=js&"
export * from "./ChatMessagesList.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessagesList.vue?vue&type=style&index=0&id=0706fa3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0706fa3c",
  null
  
)

export default component.exports